module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 42
// module chunks = 0